var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "標準代碼" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.codeId,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "codeId", $$v)
                              },
                              expression: "queryParam.codeId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "標準代碼名稱" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.codeDesc,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "codeDesc", $$v)
                              },
                              expression: "queryParam.codeDesc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "父代碼" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.codeGroup,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "codeGroup", $$v)
                              },
                              expression: "queryParam.codeGroup"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "標準代碼類型" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.codeType,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "codeType", $$v)
                              },
                              expression: "queryParam.codeType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "是否有效" } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder: "請選擇是否有效",
                                allowClear: ""
                              },
                              model: {
                                value: _vm.queryParam.codeStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParam, "codeStatus", $$v)
                                },
                                expression: "queryParam.codeStatus"
                              }
                            },
                            [
                              _c("a-select-option", { attrs: { value: "Y" } }, [
                                _vm._v("Y")
                              ]),
                              _c("a-select-option", { attrs: { value: "N" } }, [
                                _vm._v("N")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function($event) {
                  return _vm.handleExportXls("emp_chr_code")
                }
              }
            },
            [_vm._v("导出")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "sync" },
              on: { click: _vm.handleSyncAll }
            },
            [_vm._v("同步（所有）")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "sync" },
              on: { click: _vm.handleSyncByCodeType }
            },
            [_vm._v("同步（by標準類型代碼）")]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _c("p", [_vm._v("備註：")]),
              _c("p", [
                _vm._v(
                  "ELEVEL-用工類型  BU-事業群 OWNER-法人 FACTORY-廠區 SITEID-siteId JOB_ST-jobSt "
                )
              ])
            ]
          ),
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              scroll: { x: true },
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "htmlSlot",
                fn: function(text) {
                  return [_c("div", { domProps: { innerHTML: _vm._s(text) } })]
                }
              },
              {
                key: "imgSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无图片")]
                        )
                      : _c("img", {
                          staticStyle: {
                            "max-width": "80px",
                            "font-size": "12px",
                            "font-style": "italic"
                          },
                          attrs: {
                            src: _vm.getImgView(text),
                            height: "25px",
                            alt: ""
                          }
                        })
                  ]
                }
              },
              {
                key: "fileSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无文件")]
                        )
                      : _c(
                          "a-button",
                          {
                            attrs: {
                              ghost: true,
                              type: "primary",
                              icon: "download",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile(text)
                              }
                            }
                          },
                          [_vm._v("\n          下载\n        ")]
                        )
                  ]
                }
              },
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleEdit(record)
                            }
                          }
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-dropdown",
                        [
                          _c(
                            "a",
                            { staticClass: "ant-dropdown-link" },
                            [
                              _vm._v("更多 "),
                              _c("a-icon", { attrs: { type: "down" } })
                            ],
                            1
                          ),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDetail(record)
                                      }
                                    }
                                  },
                                  [_vm._v("详情")]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("emp-chr-code-modal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk }
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "同步标准代码",
            visible: _vm.syncModalVisible,
            confirmLoading: _vm.syncModalConfirmLoading
          },
          on: { ok: _vm.confirmSyncByCodeType, cancel: _vm.cancelSyncModal }
        },
        [
          _c(
            "a-form",
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "标准类型代码",
                    labelCol: { span: 6 },
                    wrapperCol: { span: 18 }
                  }
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入标准类型代码" },
                    model: {
                      value: _vm.codeTypeInput,
                      callback: function($$v) {
                        _vm.codeTypeInput = $$v
                      },
                      expression: "codeTypeInput"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }